import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import { deprecated } from '../../../../internal/propTypeValidators';
import sx from '../../../../internal/styles/sx';

const OuterLabel = styled('label', { shouldForwardProp })(
  ({ negative, invalid }) =>
    css({
      display: 'flex',
      fontFamily: 'body',
      fontSize: 'input.label',
      lineHeight: 'body',
      fontWeight: 'input.label',
      color: `input.${negative || invalid ? 'negative' : 'default'}.label`,
    }),
  sx
);

OuterLabel.propTypes = {
  negative: deprecated(PropTypes.bool),
  invalid: PropTypes.bool,
  focus: PropTypes.bool,
};

export default OuterLabel;
